// src/private/dtZones.js
// Shared Design-Thinking zone config used by InfiniteCanvas, ZoneLayer and the
// magic-cursor / kanban card placement. Coordinates are in React Flow (canvas) space.
// Layout is horizontal: Deck (left) · Brainstorming (middle) · Lavagna (right) —
// Lavagna trails last since it's the least-used board. lavagna.x here is the
// NOMINAL (tradizionale/mappatura) position only: in scenari_futuri mode
// ZoneLayer.js recomputes it dynamically, since a wide scenario tree grows
// brainstorm's width (and, when a matrix exists, inserts it between
// brainstorm and lavagna) — lavagna always trails whatever precedes it.
export const AREA_BOUNDS = {
  deck:       { x: 0,    y: -40, w: 1760, h: 2080 },
  brainstorm: { x: 1900, y: -40, w: 2200, h: 2080 },
  lavagna:    { x: 4240, y: -40, w: 1200, h: 2080 },
};

// Envelope of the 3 nominal areas (deck/lavagna/brainstorm at their base
// size, before any scenario-mode dynamic growth) — used for the startup
// zoom-to-fit so it frames the whole dashboard, not just the deck's cards.
export function getDashboardBounds() {
  const areas = Object.values(AREA_BOUNDS);
  const minX = Math.min(...areas.map((a) => a.x));
  const minY = Math.min(...areas.map((a) => a.y));
  const maxX = Math.max(...areas.map((a) => a.x + a.w));
  const maxY = Math.max(...areas.map((a) => a.y + a.h));
  return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
}

// 5 phase columns inside the brainstorm region, stepped 400px apart. 5*400=2000
// vs brainstorm's 2200 width — offset +100 from the area's left edge so the
// 200px slack splits evenly into a 100px margin on both sides (centered),
// instead of columns sitting flush against the left edge only.
export const ZONE_BASE_POSITIONS = {
  esplorazione_ideazione:        { x: 2040, y: 120 },
  prototipazione_iterazione:     { x: 2440, y: 120 },
  integrazione_implementazione:  { x: 2840, y: 120 },
  evoluzione_scalabilita:        { x: 3240, y: 120 },
  interazione_etica:             { x: 3640, y: 120 },
};

export const KANBAN_STEP = 390; // CARD_H (360) + 30 gap → no overlap
export const KANBAN_TOP = 270;  // first card y inside a column (below header chip +
                                 // evidence band; bumped +50 from 220, live-verified
                                 // with Playwright to give the wrapped evidence-chip
                                 // band room before the first card row)
export const COLUMN_W = 360;    // x hit-range width for snap detection

export const DT_ZONES = [
  { key: "esplorazione_ideazione", label: "Esplorazione e Ideazione", icon: "💜", color: "#8b5cf6" },
  { key: "prototipazione_iterazione", label: "Prototipazione e Iterazione", icon: "🛠️", color: "#ec4899" },
  { key: "integrazione_implementazione", label: "Integrazione e Implementazione", icon: "🔍", color: "#0ea5e9" },
  { key: "evoluzione_scalabilita", label: "Evoluzione e Scalabilità", icon: "💡", color: "#f59e0b" },
  { key: "interazione_etica", label: "Interazione e Etica", icon: "✅", color: "#10b981" },
];
